import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>Fatburners: makkelijk afvallen of onverstandig?</title>
                <link rel="canonical" href={route("blogs.seventeenth")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="WE ARE – personal training Uden en Schijndel komt met een nieuwe blog. Nadat we al een blog hebben geschreven over creatine en omega 3 vetzuren volgt nu een blog over fatburners. Wat is nu eigenlijk een fatburner?"
                />
                <meta
                    property="og:description"
                    content="WE ARE – personal training Uden en Schijndel komt met een nieuwe blog. Nadat we al een blog hebben geschreven over creatine en omega 3 vetzuren volgt nu een blog over fatburners. Wat is nu eigenlijk een fatburner? "
                />
                <meta property="og:url" content={route("blogs.seventeenth")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="Fatburners: makkelijk afvallen of onverstandig? - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/blog/fatburners.jpg"
                />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh]  pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/fatburners.webp"
                                    type="image/webp"
                                    alt="Fatburners"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/fatburners.jpg"
                                    type="image/jpeg"
                                    alt="Fatburners"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/fatburners.jpg"
                                    alt="Fatburners"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        Fatburners: makkelijk afvallen of onverstandig?
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        WE ARE – personal training Uden en Schijndel komt met
                        een nieuwe blog. Nadat we al een blog hebben geschreven
                        over{" "}
                        <a
                            href={route("blogs.sixteenth")}
                            className="text-we-are-yellow"
                        >
                            creatine
                        </a>{" "}
                        en{" "}
                        <a
                            href={route("blogs.fifteenth")}
                            className="text-we-are-yellow"
                        >
                            omega 3 vetzuren
                        </a>{" "}
                        volgt nu een blog over fatburners. Wat is nu eigenlijk
                        een fatburner?
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Wat is een fatburner?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Een fatburner is de benaming van een supplement die je
                        helpt om sneller vet te verbranden. Deze supplementen
                        bevatten verschillende stoffen zoals aspirine, efedrine,
                        rode peper, ginseng, synerfine en cafeïne. Het
                        belangrijkste is dat deze stoffen er samen voor zorgen
                        dat je stofwisseling versnelt, je hongergevoel wordt
                        geremd en je wordt voorzien extra energie. Hoewel het
                        geen grote verschillen realiseert worden fatburners
                        regelmatig gebruikt.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Makkelijker afvallen met een fatburner?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        De meeste mensen denken dat ze makkelijker kunnen
                        afvallen met een fatburner. Dit heeft ermee te maken dat
                        je lichaam sneller in een calorietekort komt. Doordat je
                        stofwisseling een korte boost krijgt en je honger wordt
                        onderdrukt zorgt dit ervoor dat je minder calorieën eet
                        dan dat je verbrand. Een voorbeeld: dagelijks heb je
                        2500 calorieën nodig om gelijk in gewicht te blijven.
                        Door het gebruik van fatburners eet je maar 2000
                        calorieën. Daarnaast verbrand je nog 300 calorieën meer
                        dan voorheen. Dit betekent dat je 800 calorieën tekort
                        komt (500 + 300 = 800). Door dit tekort begin je lichaam
                        vetreserves te gebruiken om dit recht te trekken.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        (On)verstandig?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Hoewel het mooi klinkt is het gebruik van fatburners
                        niet verstandig. Fatburners op de Nederlandse markt zijn
                        goed gekeurd door Voedsel en Waren autoriteit en
                        bevatten dus geen verboden stoffen. Toch zijn er een
                        aantal redenen waarom wij fatburners niet aanraden.
                    </p>
                    <ol className="mt-4 text-gray-100 list-decimal">
                        <li>
                            De hoeveel cafeïne: een fatburner bevat al snel 300
                            mg cafeïne wat gelijk staat aan ongeveer 7 koppen
                            koffie. Dit verhoogt de kans op hartritmestoornissen
                            en verstoort je slaap!
                        </li>
                        <li>
                            Geldverspilling: afvallen is kwestie van een calorie
                            tekort veroorzaken. Dit dien je te doen door minder
                            en bewuster te eten en frequent te sporten.
                            Supplementen als fatburners helpen bij dit proces
                            maar leren je niet om discipline te hebben. Alleen
                            met discipline behoud je resultaten op langer
                            termijn.
                        </li>
                        <li>
                            Prijs: een potje fatburners is relatief duur. Je
                            kunt dit geld beter steken in een abonnement op de
                            sportschool of een coach die je op een gezonde
                            manier helpen om je doelen te behalen.
                        </li>
                        <li>
                            Overdosis: fatburners doen hun werk maar wanneer je
                            ermee stopt zal je merken dat je stofwisseling weer
                            vertraagt en je minder snel afvalt. Het gevolg is
                            dat je waarschijnlijk weer begint aan fatburners. Je
                            hebt op het gegeven moment het idee dat je niet meer
                            zonder kan en raakt een soort ‘verslaafd’. Dit heeft
                            negatieve gevolgen voor je gezondheid.{" "}
                        </li>
                    </ol>
                    {/*  */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Wat is dan de oplossing?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Je kunt op veel manieren een calorie tekort veroorzaken
                        die geen negatieve gevolgen heeft voor je gezondheid. De
                        belangrijkste manier is om bewuster te gaan eten. Neem
                        vaker een salade in plaats van een hamburger, neem vaker
                        een glas water in plaats van een glas cola en eet
                        plakjes komkommer voor de televisie in plaats van een
                        zak chips. Mogelijk in{" "}
                        <a
                            href={route("blogs.second")}
                            className="text-we-are-yellow"
                        >
                            intermittent fasting
                        </a>{" "}
                        een manier die bij jou past. Daarnaast kan je meer
                        verbranden door frequent te gaan sporten. Wanneer je
                        niet meer tijd hebt kan je de intensiviteit van je
                        trainingen verhogen. Zo kan je gaan trainen in supersets
                        in plaats van losse oefeningen. Dit zijn slechts enkele
                        voorbeelden om het calorietekort te vergroten zodat je
                        gewicht blijft verliezen.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Kortom raden we het NIET aan om fatburners te gaan
                        gebruiken. Leer bewust en gezond te eten en frequent te
                        trainen. Rome is ook niet in één dag gebouwd!
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
